import * as types from '../constants';
import localStorage from 'store';

const token = localStorage.get('token') ?? null;
const user = localStorage.get('user') ?? null;

let initialState = {
  user: user || {},
  token,
  isAuthenticated: !!token,
  isLoading: false,
  vErrors: null,
  vMessage: null,
  data: null,
  forgotData: null,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case types.SET_LOADER:
      return {
        ...state,
        isLoading: payload,
      };
    case types.LOGIN_START:
      return {
        ...state,
        isAuthenticated: false,
        isLoading: true,
        vErrors: null,
      };
    case types.LOGIN_SUCCESS:
      return {
        ...state,
        token: payload.token,
        user: payload.user,
        isAuthenticated: true,
        isLoading: false,
      };
    case types.LOGIN_FAILURE:
      return {
        ...state,
        isAuthenticated: false,
        isLoading: false,
      };
    case types.SET_USER:
      return {
        ...state,
        user: payload,
      };
    case types.LOGOUT:
      return {
        ...state,
        token: null,
        isAuthenticated: false,
        user: null,
      };
    case types.SET_V_ERRORS:
      return {
        ...state,
        vErrors: payload,
        vMessage: null,
      };
    case types.FORGOT_PASSWORD_START:
      return {
        ...state,
        isLoading: true,
        data: null,
      };
    case types.FORGOT_PASSWORD_SUCCESS:
      return {
        ...state,
        data: payload,
        isLoading: false,
      };
    case types.FORGOT_PASSWORD_FAILURE:
      return {
        ...state,
        isLoading: false,
        data: null,
      };
    case types.RESET_PASSWORD_START:
      return {
        ...state,
        isLoading: true,
        data: null,
      };
    case types.RESET_PASSWORD_SUCCESS:
      return {
        ...state,
        isLoading: false,
        data: payload,
      };
    case types.RESET_PASSWORD_FAILURE:
      return {
        ...state,
        isLoading: false,
        data: null,
      };
    case types.SET_MESSAGE:
      return {
        ...state,
        isLoading: false,
        data: payload,
      };
    case types.SET_V_MESSAGES:
      return {
        ...state,
        vMessage: payload,
      };
    case types.SET_FORGOT_DATA:
      return {
        ...state,
        forgotData: payload,
      };
    default:
      return state;
  }
};
